module.exports = __webpack_public_path__ + "static/media/sidebar-button.fc8b98c5.svg";